import { useCallback, useEffect, useRef, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "../components/ui/dialog";
import { Check, ChevronDown, Plus } from "lucide-react";
import PlaceCard from "./PlaceCard";

const PlaceDetailModal = ({ place, isOpen, onClose, isSelected, onToggle }) => {
  // the card goes on below the fold, and testers never knew (2026-10-08): a cue until they reach the end
  const scroller = useRef(null);
  const [more, setMore] = useState(false);
  const measure = useCallback(() => {
    const el = scroller.current;
    setMore(!!el && el.scrollHeight - el.scrollTop - el.clientHeight > 40);
  }, []);
  useEffect(() => {
    if (!isOpen) return undefined;
    const timer = setTimeout(measure, 120);   // after the dialog and its photo have laid out
    return () => clearTimeout(timer);
  }, [isOpen, place, measure]);

  if (!place) return null;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent
        className="p-0 overflow-hidden rounded-2xl max-w-md w-[calc(100vw-2rem)]"
        style={{ background: "var(--zen-bg)", border: "1px solid var(--zen-border)", maxHeight: "90svh", display: "block" }}
        data-testid="place-detail-modal"
      >
        <DialogTitle className="sr-only">{place.name}</DialogTitle>
        <div ref={scroller} onScroll={measure} style={{ maxHeight: "90svh", overflowY: "auto" }}>
          <PlaceCard
            place={place}
            footer={(
              <div className="px-5 pb-5 pt-3" style={{ background: "var(--zen-bg)" }}>
                <button
                  onClick={(e) => { e.stopPropagation(); onToggle(); }}
                  className="w-full flex items-center justify-center gap-2 py-2.5 rounded-xl text-sm font-medium transition-all hover:opacity-90"
                  style={{
                    background: isSelected ? "transparent" : "var(--zen-accent)",
                    color: isSelected ? "var(--zen-sub)" : "#fff",
                    border: `1.5px solid ${isSelected ? "var(--zen-border-h)" : "var(--zen-accent)"}`,
                  }}
                  data-testid="modal-toggle-btn"
                >
                  {isSelected ? (
                    <>
                      <Check className="w-4 h-4" /> In your plan
                    </>
                  ) : (
                    <>
                      <Plus className="w-4 h-4" /> Add to my plan
                    </>
                  )}
                </button>
              </div>
            )}
          />
        </div>
        {more && (
          <button type="button" aria-label="Scroll down for more"
            onClick={() => scroller.current?.scrollBy({ top: scroller.current.clientHeight * 0.7, behavior: "smooth" })}
            className="absolute left-1/2 -translate-x-1/2 flex items-center gap-1 px-3 py-1.5 rounded-full text-xs font-semibold"
            style={{ bottom: 14, background: "var(--zen-text)", color: "var(--zen-bg)", border: 0, boxShadow: "0 2px 10px rgba(0,0,0,0.25)", cursor: "pointer" }}
            data-testid="modal-more-below">
            More below <ChevronDown className="w-3.5 h-3.5" />
          </button>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default PlaceDetailModal;
